import { render, staticRenderFns } from "./askpriceform.vue?vue&type=template&id=74420998&scoped=true"
import script from "./askpriceform.vue?vue&type=script&lang=js"
export * from "./askpriceform.vue?vue&type=script&lang=js"
import style0 from "./askpriceform.vue?vue&type=style&index=0&id=74420998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74420998",
  null
  
)

export default component.exports